import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/retour.png'


const _withScopeId = n => (_pushScopeId("data-v-2342c770"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "size-9"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 0 1 1.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.559.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.894.149c-.424.07-.764.383-.929.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 0 1-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.398.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 0 1-.12-1.45l.527-.737c.25-.35.272-.806.108-1.204-.165-.397-.506-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.108-1.204l-.526-.738a1.125 1.125 0 0 1 .12-1.45l.773-.773a1.125 1.125 0 0 1 1.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
  })
], -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  id: "options",
  class: "hidden w-96 absolute top-16 left-2 rounded-md"
}
const _hoisted_4 = { class: "bg-white w-full rounded-md shadow-lg p-4 flex flex-col items-center space-y-4" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<h2 class=\"text-xl text-blue-600 font-bold\" data-v-2342c770>Formules</h2><table class=\"w-full text-sm text-center border border-gray-300\" data-v-2342c770><thead class=\"bg-gray-100 text-gray-700\" data-v-2342c770><tr data-v-2342c770><th class=\"border border-gray-300 px-2 py-1\" data-v-2342c770></th><th class=\"border border-gray-300 px-2 py-1\" data-v-2342c770>vitesse</th><th class=\"border border-gray-300 px-2 py-1\" data-v-2342c770>accélération</th></tr></thead><tbody data-v-2342c770><tr data-v-2342c770><td class=\"border border-gray-300 font-bold px-2 py-1\" data-v-2342c770>m.r.u.</td><td class=\"border border-gray-300 px-2 py-1\" data-v-2342c770>v = Δx / Δt</td><td class=\"border border-gray-300 px-2 py-1\" data-v-2342c770>0</td></tr><tr data-v-2342c770><td class=\"border border-gray-300 font-bold px-2 py-1\" data-v-2342c770>m.r.u.a.</td><td class=\"border border-gray-300 px-2 py-1\" data-v-2342c770>v = a · t</td><td class=\"border border-gray-300 px-2 py-1\" data-v-2342c770>a = Δv / Δt</td></tr></tbody></table>", 2)
const _hoisted_7 = {
  key: 0,
  class: "bg-white absolute top-12 right-16 w-96 h-96 pb-24"
}
const _hoisted_8 = { class: "grid grid-cols-2 text-center mb-5" }
const _hoisted_9 = {
  key: 0,
  class: "w-full h-full"
}
const _hoisted_10 = {
  key: 1,
  class: "w-full h-full"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("canvas", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-16 h-16 bg-blue-500 rounded-full",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Questions = _resolveComponent("Questions")!
  const _component_LineChart = _resolveComponent("LineChart")!
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Questions, {
      id: "card",
      Presentation: "Découvrez le mouvement rectiligne uniforme à travers nos expériences interactives ! Ce type de mouvement, où un objet se déplace en ligne droite à une vitesse constante, fait partie des bases de la dynamique. Explorez comment les objets parcourent des distances égales en des temps égaux.",
      titre: "Le Mouvement rectiligne",
      cacherCard: _ctx.cacherCard,
      questions: _ctx.questions,
      fichier: "mvt_uniforme_variee"
    }, null, 8, ["cacherCard", "questions"]),
    _createElementVNode("main", {
      class: _normalizeClass({ 'blur-sm': _ctx.flou == true })
    }, [
      _createElementVNode("div", {
        class: "absolute top-2 left-2 bg-white py-3 px-4 bg-white rounded-full flex justify-center items-center cursor-pointer",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.testfinal && _ctx.testfinal(...args)))
      }, " Fin de la simulation "),
      _createElementVNode("div", {
        class: "absolute bottom-2 left-2 bg-white w-16 h-16 rounded-full flex justify-center items-center cursor-pointer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.gererVisibilite('options')))
      }, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            class: "bg-blue-300 text-white px-3 py-2 w-52 text-center cursor-pointer",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleGraphique()))
          }, _toDisplayString(_ctx.graphique ? "Masquer les graphiques" : "Voir les graphiques"), 1)
        ])
      ]),
      (_ctx.graphique)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                class: _normalizeClass(["cursor-pointer", {'bg-blue-300': _ctx.currentExp}]),
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.changerExp && _ctx.changerExp(...args)))
              }, "MRU", 2),
              _createElementVNode("div", {
                class: _normalizeClass(["cursor-pointer", {'bg-blue-300': !_ctx.currentExp}]),
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.changerExp && _ctx.changerExp(...args)))
              }, "MRUV", 2)
            ]),
            (_ctx.exp =='mruv')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_LineChart, {
                    data: _ctx.chartData,
                    options: _ctx.chartOptions
                  }, null, 8, ["data", "options"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.exp=='mru')
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_LineChart, {
                    data: _ctx.chartData2,
                    options: _ctx.chartOptions2
                  }, null, 8, ["data", "options"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_LoadingScreen, { isLoaded: _ctx.loaded }, null, 8, ["isLoaded"]),
      _hoisted_11,
      _createElementVNode("div", {
        class: "fixed z-40 right-2 bottom-5 w-16 h-16",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.actualiser && _ctx.actualiser(...args)))
      }, _hoisted_13)
    ], 2)
  ]))
}